import PropTypes from 'prop-types';
import React from 'react';
import translations from '../../translations';

const SupportTag = (props) =>
    props.supportedBy && translations.supportTags.tag[props.supportedBy] ? (
        <span className={props.className} data-tooltip={translations.supportTags.tooltip[props.supportedBy]}>
            {translations.supportTags.tag[props.supportedBy]}
        </span>
    ) : null;

SupportTag.propTypes = {
    supportedBy: PropTypes.string,
    className: PropTypes.string,
};

export default SupportTag;
